import React from "react";

interface Props {
  label: string;
  layout?: "inline" | "page";
}

const pageLayoutStyle: React.CSSProperties = {
  position: "absolute",
  inset: 0,
  minHeight: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

export const LoadingState = ({ label, layout = "inline" }: Props) => {
  return (
    <div
      className={layout === "page" ? "page-loading-state" : undefined}
      style={layout === "page" ? pageLayoutStyle : undefined}
    >
      <div className="loading-state" role="status" aria-live="polite">
        <span className="spinner" aria-hidden="true" />
        <span>{label}</span>
      </div>
    </div>
  );
};
